var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _circle4, _path10, _circle5, _path11, _circle6, _path12, _path13, _path14, _path15, _ellipse, _ellipse2, _path16, _path17, _path18, _polygon, _path19, _polygon2, _path20, _path21, _circle7, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscussionNoComments(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 745.78294,
    height: 510,
    viewBox: "0 0 745.78294 510",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M666.03421,647.67542c7.18382,12.69813,1.0921,55.58546,1.0921,55.58546s-39.89068-16.88558-47.07316-29.57842a26.41318,26.41318,0,1,1,45.98106-26.007Z",
    transform: "translate(-227.10853 -195)",
    fill: "#f1f1f1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M667.70473,703.20558l-.84744.17852c-8.16221-38.77834-36.66552-65.075-36.95246-65.33607l.58273-.64064C630.77656,637.67015,659.48321,664.14565,667.70473,703.20558Z",
    transform: "translate(-227.10853 -195)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M731.30564,662.13423c-9.74789,17.68309-64.70648,41.63829-64.70648,41.63829s-9.06086-59.26311.68177-76.94078a36.55622,36.55622,0,1,1,64.02471,35.30249Z",
    transform: "translate(-227.10853 -195)",
    fill: "#f1f1f1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M667.08422,704.414l-.82555-.869c39.76932-37.7685,50.06448-90.44509,50.16385-90.97275l1.17793.2216C717.50062,613.32511,707.1423,666.37115,667.08422,704.414Z",
    transform: "translate(-227.10853 -195)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "e53b7fd6-ae48-4231-a6bf-c74c7a6312f6",
    "data-name": "Rectangle 62",
    x: 0.30072,
    y: 19.33529,
    width: 705.26456,
    height: 334.66027,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "e27b5d17-8fe1-40fd-abc5-ff1fb7c5af81",
    "data-name": "Rectangle 75",
    x: 20.468,
    y: 48.033,
    width: 664.93099,
    height: 279.21753,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "f11de06d-5237-47a5-bdcf-7ab24c90f6f6",
    "data-name": "Rectangle 80",
    width: 705.26456,
    height: 29.96173,
    fill: "#6c63ff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "a8620065-6204-4575-b165-05df1e96cc70",
    "data-name": "Ellipse 90",
    cx: 22.26529,
    cy: 15.62776,
    r: 5.5533,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "b36f18db-17cf-43fd-9307-66e7abd9e79c",
    "data-name": "Ellipse 91",
    cx: 43.34377,
    cy: 15.62776,
    r: 5.5533,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "f951b331-c7b3-4c65-b7ff-4fae542bffe1",
    "data-name": "Ellipse 92",
    cx: 64.42323,
    cy: 15.62776,
    r: 5.5533,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "f1fe0bb1-d2c3-44f1-a2df-b8ed042349d0-11",
    "data-name": "Path 142",
    d: "M508.3695,327.32281c-1.49465.005-2.70394,2.05262-2.701,4.57349.003,2.51383,1.21051,4.55046,2.701,4.55542H786.81178c1.49466-.005,2.70394-2.05262,2.701-4.57349-.003-2.51383-1.21052-4.55047-2.701-4.55542Z",
    transform: "translate(-227.10853 -195)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "b5b576d4-2c69-432d-bba9-c1d1eb12c444-12",
    "data-name": "Path 143",
    d: "M508.3695,354.71213c-1.49465.005-2.70394,2.05262-2.701,4.57349.003,2.51383,1.21051,4.55046,2.701,4.55542H714.123c1.49466-.005,2.70394-2.05262,2.701-4.57349-.003-2.51383-1.21052-4.55046-2.701-4.55542Z",
    transform: "translate(-227.10853 -195)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "e1a4eb85-7f76-47c7-ae93-e7842353edb9-13",
    "data-name": "Path 142",
    d: "M508.3695,381.48176c-1.49465.005-2.70394,2.05263-2.701,4.57349.003,2.51384,1.21051,4.55047,2.701,4.55543H786.81178c1.49466-.005,2.70394-2.05263,2.701-4.57349-.003-2.51383-1.21052-4.55047-2.701-4.55543Z",
    transform: "translate(-227.10853 -195)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "bd9e3462-ca4d-47f6-a5ea-71b97a8587f8-14",
    "data-name": "Path 143",
    d: "M508.3695,408.87108c-1.49465.005-2.70394,2.05263-2.701,4.5735.003,2.51383,1.21051,4.55046,2.701,4.55542H714.123c1.49466-.005,2.70394-2.05262,2.701-4.57349-.003-2.51383-1.21052-4.55047-2.701-4.55543Z",
    transform: "translate(-227.10853 -195)",
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "f71eedc3-aadd-4340-a501-e921cec01e8f-15",
    "data-name": "Path 142",
    d: "M292.29592,428.32281c-1.49466.005-2.704,2.05262-2.701,4.57349.003,2.51383,1.21051,4.55046,2.701,4.55542H429.73819c1.49466-.005,2.70394-2.05262,2.701-4.57349-.003-2.51383-1.21051-4.55047-2.701-4.55542Z",
    transform: "translate(-227.10853 -195)",
    fill: "#e6e6e6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "b1fed777-acdd-4ce8-9b40-ebd2535d8bb3-16",
    "data-name": "Path 143",
    d: "M292.29592,455.71213c-1.49466.005-2.704,2.05262-2.701,4.57349.003,2.51383,1.21051,4.55046,2.701,4.55542h64.75347c1.49466-.005,2.70394-2.05262,2.701-4.57349-.003-2.51383-1.21051-4.55046-2.701-4.55542Z",
    transform: "translate(-227.10853 -195)",
    fill: "#e6e6e6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M413.62866,312.60586a55.70922,55.70922,0,1,0-96.27,52.92c.5.63,1.02,1.26,1.54981,1.87.04.04.06982.08.10986.12a54.13689,54.13689,0,0,0,4.15039,4.28c.37988.35.77978.71,1.17969,1.05.76025.68,1.54,1.33,2.35009,1.95a54.77547,54.77547,0,0,0,4.94,3.47l.06.03c1.10987.69,2.23975,1.33,3.39014,1.94l.46973.24c1.08008.56,2.18017,1.09,3.31006,1.58.23.1.48.2.71.3.02.01.03027.01.05029.02a54.11484,54.11484,0,0,0,7.02,2.37,55.73235,55.73235,0,0,0,14.36963,1.88c1.77,0,3.52-.08,5.25-.25a55.50816,55.50816,0,0,0,11.64014-2.35c.01025,0,.02-.01.02978-.01a54.6047,54.6047,0,0,0,6.99023-2.77c.00977-.01.03028-.01.04-.02.50977-.24,1-.5,1.5-.75l.24024-.12c.3999-.21.7998-.42005,1.19971-.64,1-.55,1.98-1.13,2.95019-1.75.27-.16.52979-.33.79981-.51.87988-.58,1.75-1.2,2.58984-1.83.15039-.11.31006-.22.46045-.34a55.69207,55.69207,0,0,0,18.91992-62.68Z",
    transform: "translate(-227.10853 -195)",
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "b315fec5-366f-4a16-9dc9-634679b82ba4",
    "data-name": "Ellipse 188",
    cx: 152.29372,
    cy: 150.53123,
    r: 8.349,
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "fd00c811-5154-4e0f-bd90-f718730f637f-17",
    "data-name": "Path 969",
    d: "M381.72829,337.41224a8.35,8.35,0,0,1,7.35,12.312,8.347,8.347,0,1,0-13.868-9.172,8.32914,8.32914,0,0,1,6.519-3.14Z",
    transform: "translate(-227.10853 -195)",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "b073881c-6d17-4b63-9208-a633e233f752",
    "data-name": "Ellipse 189",
    cx: 136.69172,
    cy: 125.98723,
    r: 24.526,
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "e068fb34-c64f-4621-9a6c-47926968fe63-18",
    "data-name": "Path 970",
    d: "M344.55123,305.77027a24.522,24.522,0,0,1,33.99-2.572c-.2-.191-.4-.383-.607-.568a24.526,24.526,0,0,0-32.73016,36.5354q.06985.06253.14013.12458c.208.185.422.36.635.537a24.522,24.522,0,0,1-1.427-34.057Z",
    transform: "translate(-227.10853 -195)",
    fill: "#2f2e41"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "baa61e83-3b6b-4f74-a8d9-0c51f3f7a212",
    "data-name": "Ellipse 190",
    cx: 136.48371,
    cy: 134.50923,
    r: 15.796,
    fill: "#a0616a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M391.85864,370.66586v5.3c-.97021.62-1.95019,1.2-2.95019,1.75-.39991.22-.79981.43-1.19971.64l-.24024.12c-.5.25-.99023.51-1.5.75-.00976.01-.03027.01-.04.02a54.6047,54.6047,0,0,1-6.99023,2.77c-.00977,0-.01953.01-.02978.01a55.50816,55.50816,0,0,1-11.64014,2.35c-1.73.17-3.48.25-5.25.25a55.73235,55.73235,0,0,1-14.36963-1.88,54.11484,54.11484,0,0,1-7.02-2.37c-.02-.01-.03027-.01-.05029-.02-.23-.1-.48-.2-.71-.3-1.12989-.49-2.23-1.02-3.31006-1.58l-.46973-.24c-1.15039-.61-2.28027-1.25-3.39014-1.94l-.06-.03a54.77547,54.77547,0,0,1-4.94-3.47c-.81-.62-1.58984-1.27-2.35009-1.95-.39991-.34-.79981-.7-1.17969-1.05a54.13689,54.13689,0,0,1-4.15039-4.28,20.22982,20.22982,0,0,1,.76025-3.07l.00977-.01a4.48938,4.48938,0,0,1,.21-.5,3.98893,3.98893,0,0,1,.18994-.42c1.79-3.35,5.03027-4.18,9.05029-4.36,2.27-.1,4.77979.01,7.43018-.02,1.3999-.01,2.84961-.06,4.2998-.19,9.14991-.83,7.49024-6.23,7.89991-9.14.41015-2.82,2.95019-.37994,3.12011-.22l.00977.01a32.27157,32.27157,0,0,0,16.6001,2.91c.98-.12,1.96-.19,2.93994-.22,2.58008-.03,2.02.71,1.13037,1.32a11.18308,11.18308,0,0,1-1.3501.76s-.41015,2.5-.83008,6.24c-.3999,3.57995,6.46,5.26,7.02979,5.38995a.06082.06082,0,0,0,.04.01,13.77359,13.77359,0,0,1,7.61035.2h.00976A9.018,9.018,0,0,1,391.85864,370.66586Z",
    transform: "translate(-227.10853 -195)",
    fill: "#cbcbcb"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M340.72827,377.09585c0,.74-.01953,1.45-.04981,2.12-.00976.4-.02978.79-.0498,1.16-.02-.01-.03027-.01-.05029-.02-.23-.1-.48-.2-.71-.3-1.12989-.49-2.23-1.02-3.31006-1.58l-.46973-.24c-1.15039-.61-2.28027-1.25-3.39014-1.94.02979-.35.08008-.7.12989-1.05.10986-.77.20019-1.55.26025-2.31994a32.1836,32.1836,0,0,0-2.8501-15.76v-.01c-.20019-.4-.31982-.62-.31982-.62s2.90967-2.5,7.05957,0a2.4977,2.4977,0,0,1,.69043.6C340.1687,360.08584,340.84839,370.00582,340.72827,377.09585Z",
    transform: "translate(-227.10853 -195)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M386.13843,375.73586c-.04,1.12-.1001,2.29-.16993,3.48v.01c-.00976.01-.03027.01-.04.02a54.6047,54.6047,0,0,1-6.99023,2.77c-.00977,0-.01953.01-.02978.01l-.10987-2.81-.01025-.37-.52979-13.68a2.29521,2.29521,0,0,1,2.29-2.4h5.06983c.25,0,.43017.51.55029,1.43v.01A86.66139,86.66139,0,0,1,386.13843,375.73586Z",
    transform: "translate(-227.10853 -195)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "b5d95f6e-bcc4-4382-8a9f-8ff393651dfe-19",
    "data-name": "Path 975",
    d: "M350.08223,309.76422v15.8h3.658l4.655-4.988-.623,4.988h16.17l-1-4.988,2,4.988h2.578v-15.8Z",
    transform: "translate(-227.10853 -195)",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "a1555f60-b18f-4a81-9968-ab91697ea211",
    "data-name": "Ellipse 191",
    cx: 120.47972,
    cy: 131.18423,
    rx: 1.247,
    ry: 2.286,
    fill: "#a0616a"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "b9487e3b-2bf5-437d-8cc7-b19d17f64c32",
    "data-name": "Ellipse 192",
    cx: 152.48872,
    cy: 131.18423,
    rx: 1.247,
    ry: 2.286,
    fill: "#a0616a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M413.62866,312.60586a55.70922,55.70922,0,1,0-96.27,52.92c.5.63,1.02,1.26,1.54981,1.87.04.04.06982.08.10986.12a54.13689,54.13689,0,0,0,4.15039,4.28c.37988.35.77978.71,1.17969,1.05.76025.68,1.54,1.33,2.35009,1.95a54.77547,54.77547,0,0,0,4.94,3.47l.06.03c1.10987.69,2.23975,1.33,3.39014,1.94l.46973.24c1.08008.56,2.18017,1.09,3.31006,1.58.23.1.48.2.71.3.02.01.03027.01.05029.02a54.11484,54.11484,0,0,0,7.02,2.37,55.73235,55.73235,0,0,0,14.36963,1.88c1.77,0,3.52-.08,5.25-.25a55.50816,55.50816,0,0,0,11.64014-2.35c.01025,0,.02-.01.02978-.01a54.6047,54.6047,0,0,0,6.99023-2.77c.00977-.01.03028-.01.04-.02.50977-.24,1-.5,1.5-.75l.24024-.12c.3999-.21.7998-.42005,1.19971-.64,1-.55,1.98-1.13,2.95019-1.75.27-.16.52979-.33.79981-.51.87988-.58,1.75-1.2,2.58984-1.83.15039-.11.31006-.22.46045-.34a55.69207,55.69207,0,0,0,18.91992-62.68Zm-20.76025,60.25c-.33008.26-.66993.51-1.00977.74-.33008.25-.66016.49-1,.71-.29.21-.58008.41-.88037.6-.25.17-.5.33-.75.49q-1.24439.78-2.51953,1.5c-.09033.05-.18018.1-.27051.15-.37988.21-.75977.41-1.13965.61-.05029.03-.11035.05-.16015.08l-.06006.03c-.48.25-.96973.49-1.46.72a49.02816,49.02816,0,0,1-5.83008,2.36c-.25977.09-.52.18-.77979.26a52.45729,52.45729,0,0,1-11.02,2.24c-1.64013.15-3.30029.23-4.97021.23a51.952,51.952,0,0,1-13.58985-1.78,49.3912,49.3912,0,0,1-6.66992-2.26c-.23-.09-.46-.19-.68017-.28-.11963-.05-.23-.1-.3501-.16-.93994-.41-1.86963-.86-2.77979-1.33l-.43994-.23c-1.10986-.58-2.20019-1.2-3.26025-1.86-.38965-.24006-.77979-.49006-1.15967-.75-1.20019-.79-2.37012-1.64-3.51025-2.53-.77-.58-1.50977-1.2-2.23-1.84-.37989-.32-.75-.67-1.10987-1a50.88254,50.88254,0,0,1-4.02-4.16c-.41992-.48-.83007-.96-1.22021-1.46a3.80064,3.80064,0,0,1-.25-.31,52.65906,52.65906,0,1,1,73.12012,9.23Z",
    transform: "translate(-227.10853 -195)",
    fill: "#cbcbcb"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M756.35257,396.14592a11.628,11.628,0,0,1,1.39117,1.19072l53.754-10.60251,4.3188-12.59026,19.85283,4.03439-5.47954,23.03159a8.83824,8.83824,0,0,1-8.156,6.78152l-62.25532,3.11909a11.597,11.597,0,1,1-3.42591-14.96454Z",
    transform: "translate(-227.10853 -195)",
    fill: "#ffb7b7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M810.18839,384.24407a4.96616,4.96616,0,0,1-.35879-4.1241L818.22,356.621a13.8069,13.8069,0,0,1,27.10259,5.28823l-1.21492,25.00337a4.97153,4.97153,0,0,1-5.932,4.63509l-24.63-4.88074A4.96591,4.96591,0,0,1,810.18839,384.24407Z",
    transform: "translate(-227.10853 -195)",
    fill: "#6c63ff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "569.599 494.016 553.795 494.015 546.277 433.059 569.601 433.06 569.599 494.016",
    fill: "#ffb7b7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M800.7373,704.3346l-50.95641-.00189v-.64452a19.83474,19.83474,0,0,1,19.83366-19.83334h.00126l31.12244.00126Z",
    transform: "translate(-227.10853 -195)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "719.25 477.453 704.614 483.412 674.665 429.791 696.268 420.997 719.25 477.453",
    fill: "#ffb7b7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M955.86824,685.12148,908.67277,704.3346l-.243-.59694a19.83471,19.83471,0,0,1,10.89067-25.84818l.00117-.00048L948.147,666.15438Z",
    transform: "translate(-227.10853 -195)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M811.08538,435.9013l-7.27131-38.47223,0,0a39.04222,39.04222,0,0,1,6.00845-33.42771l26.58221-35.54112,25.38975.74676,0,0A144.96483,144.96483,0,0,1,868.092,420.9732l-4.667,17.95339c20.93017,18.87846,34.963,71.8092,47.73613,130.95735l35.01682,77.4416-60.2437,18.29-39.03108-113.5724L812.03674,666.46047,760.98225,664.501,799.81362,487.5195Z",
    transform: "translate(-227.10853 -195)",
    fill: "#2f2e41"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 624.43016,
    cy: 101.50853,
    r: 24.7683,
    fill: "#ffb7b7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M949.30468,352.76493c-4.60149-8.98849-6.172-19.19487-9.71361-28.65132-3.54185-9.45646-9.97631-18.83868-19.732-21.44491-5.53361-1.47831-11.41387-.57586-17.09816-1.27969-4.99788-.61882-10.37885-3.17057-12.29281-7.60939a31.34819,31.34819,0,0,0-1.61262-13.00538C885.29,270.6435,876.78718,262.646,866.87464,258.5117c-8.05176-3.35848-17.32418-4.307-25.54679-1.39054s-15.12462,10.0442-16.60281,18.64246c-1.47819,8.59832,3.26167,18.1993,11.43357,21.25348,5.86746,2.19285,13.42386,1.46274,17.25524,6.4184,3.88111,5.02034,1.099,12.33682-2.42606,17.61327l.24078.24485c11.51383.135,23.95978-2.08982,31.88992-10.43806a25.26673,25.26673,0,0,0,2.36894-2.91471c.24275.38968.49733.76975.7711,1.13283,3.99338,5.30274,10.24492,8.31095,16.201,11.24166,5.95658,2.93078,12.13377,6.22,15.71107,11.8118,6.46474,10.10519,2.22122,23.71512,5.91817,35.12746a25.94909,25.94909,0,0,0,48.80269,1.58258C962.8285,369.67783,953.90618,361.75348,949.30468,352.76493Z",
    transform: "translate(-227.10853 -195)",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M709.273,416.14546l1.04786-25.4511,35.9462-71.46937a10.36832,10.36832,0,0,1,4.70375-4.67666,10.49,10.49,0,0,1,8.1044-.52915,10.48613,10.48613,0,0,1,6.5397,6.6276,10.84685,10.84685,0,0,1,.45528,2.03538,10.38645,10.38645,0,0,1-1.04243,5.97871l-35.9949,71.56621Z",
    transform: "translate(-227.10853 -195)",
    fill: "#6c63ff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M755.44752,313.94722l-39.01961,77.58-2.975-1.49629,37.739-75.0339A9.94472,9.94472,0,0,1,755.44752,313.94722Z",
    transform: "translate(-227.10853 -195)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M765.574,322.74552l-37.53234,74.623-2.975-1.4963L764.00541,318.453a9.9978,9.9978,0,0,1,1.1347,2.35046A10.32757,10.32757,0,0,1,765.574,322.74552Z",
    transform: "translate(-227.10853 -195)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M761.83755,316.0866,722.3866,394.52422l-2.975-1.49629L758.912,314.49205a9.688,9.688,0,0,1,1.2287.51721A10.19811,10.19811,0,0,1,761.83755,316.0866Z",
    transform: "translate(-227.10853 -195)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M713.78577,411.86916l-3.96976,3.19722.33277-8.42931C711.51182,407.10994,712.98747,409.16176,713.78577,411.86916Z",
    transform: "translate(-227.10853 -195)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M754.71661,331.74677a11.62926,11.62926,0,0,1,.26437,1.812l47.45853,27.37864,11.53546-6.64076,12.29749,16.09916-19.27879,13.74074a8.83824,8.83824,0,0,1-10.60389-.25833l-48.93791-38.60746a11.597,11.597,0,1,1,7.26474-13.524Z",
    transform: "translate(-227.10853 -195)",
    fill: "#ffb7b7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M803.09159,358.2007a4.96617,4.96617,0,0,1,2.44295-3.342L827.313,342.681a13.80689,13.80689,0,0,1,16.93256,21.81292l-17.36418,18.03135a4.97154,4.97154,0,0,1-7.51684-.41172l-15.33848-19.87937A4.966,4.966,0,0,1,803.09159,358.2007Z",
    transform: "translate(-227.10853 -195)",
    fill: "#6c63ff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M969.73631,705h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-227.10853 -195)",
    fill: "#cbcbcb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscussionNoComments);
export default __webpack_public_path__ + "static/media/discussion-no-comments.4422a2e7e5497385865902c3ac54cb1e.svg";
export { ForwardRef as ReactComponent };